/**
 * @returns {(number)} - return corporate brand ID.
 */
const getCorporateBrandId = () => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'hm':
            return 0;
        case 'cos':
            return 1;
        case 'monki':
            return 2;
        case 'otherStories':
            return 5;
        case 'arket':
            return 6;
        default:
            return 0;
    }
};
export default getCorporateBrandId;
//# sourceMappingURL=getCorporateBrandId.js.map